import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { receiveIssueCategories } from '@sophocles/entities/IssueCategory';
import { IssueSubCategory, issueSubCategorySchema } from '@sophocles/entities/IssueSubCategory/issueSubCategoryRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_ISSUE_SUB_CATEGORIES = 'RECEIVE_ISSUE_SUB_CATEGORIES';
function receiveIssueSubCategories(json) {
  return {
    type: RECEIVE_ISSUE_SUB_CATEGORIES,
    issueSubCategories: mapListToRecords(json, IssueSubCategory),
  };
}

/* Request Actions */
// starter request
export const REQUEST_ISSUE_SUB_CATEGORY = 'REQUEST_ISSUE_SUB_CATEGORY';
function requestIssueSubCategory(issueSubCategory_id) {
  return {
    type: REQUEST_ISSUE_SUB_CATEGORY,
    issueSubCategory_id,
  };
}

export const REQUEST_ALL_ISSUE_SUB_CATEGORIES = 'REQUEST_ALL_ISSUE_SUB_CATEGORIES';
function requestAllIssues() {
  return {
    type: REQUEST_ALL_ISSUE_SUB_CATEGORIES,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchAllIssues() {
  return dispatch => {
    dispatch(requestAllIssues());
    return apiClient
      .get(`/issuesubcategories/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'issueSubCategories', issueSubCategorySchema))
      .then(json => {
        dispatch(receiveIssueCategories(json.entities.issueCategories));
        return dispatch(receiveIssueSubCategories(json.entities.issueSubCategories));
      })
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_ISSUE_SUB_CATEGORIES)));
  };
}

// For issue creation page
export function fetchAllIssuesForCreation() {
  return dispatch => {
    dispatch(requestAllIssues());
    return apiClient
      .get(`/issuesubcategories/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_ALL_ISSUE_SUB_CATEGORIES)));
  };
}

/* Edit Actions */
export const EDIT_ISSUE_SUB_CATEGORY = 'EDIT_ISSUE_SUB_CATEGORY';
export function editIssueSubCategory(issueSubCategory_id) {
  return {
    type: EDIT_ISSUE_SUB_CATEGORY,
    issueSubCategory: issueSubCategory_id,
  };
}

export function patchIssueSubCategory(issueSubCategory_id, values) {
  return dispatch => {
    dispatch(editIssueSubCategory(issueSubCategory_id));
    return apiClient
      .patch(`/issuesubcategories/${issueSubCategory_id}/?limit=10000`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, issueSubCategorySchema))
      .then(json => dispatch(receiveIssueSubCategories(json.entities.issueSubCategories)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_ISSUE_SUB_CATEGORY)));
  };
}

/* Create Actions */
export const CREATE_ISSUE_SUB_CATEGORY = 'CREATE_ISSUE_SUB_CATEGORY';
function sayCreateIssueSubCategory(values) {
  return {
    type: CREATE_ISSUE_SUB_CATEGORY,
    values: values,
  };
}

export function createIssueSubCategory(values) {
  return dispatch => {
    dispatch(sayCreateIssueSubCategory(values));
    return apiClient
      .post(`/issuesubcategories/?limit=10000`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, issueSubCategorySchema))
      .then(json => dispatch(receiveIssueSubCategories(json.entities.issueSubCategories)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_ISSUE_SUB_CATEGORY)));
  };
}

/* Delete Actions */
export const DELETE_ISSUE_SUB_CATEGORY = 'DELETE_ISSUE_SUB_CATEGORY';
function sayDeleteIssueSubCategory(issueSubCategory_id) {
  return {
    type: DELETE_ISSUE_SUB_CATEGORY,
    issueSubCategory: issueSubCategory_id,
  };
}

export function deleteIssueSubCategory(issueSubCategory_id) {
  return dispatch =>
    apiClient
      .delete(`/issuesubcategories/${issueSubCategory_id}/?limit=10000`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteIssueSubCategory(issueSubCategory_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_ISSUE_SUB_CATEGORY)));
}
